/**
 * Economy / Test mode resolution — the network-wide 'Shared' cheap-run toggle.
 *
 * Single source of truth for the frontend's default-ON semantics, mirroring the backend
 * (``stepflow_core.release_resolution._is_economy_on`` /
 * ``runner.execute_network._resolve_economy_mode``): a network runs cheap OUT OF THE BOX, and
 * the user OPTS OUT (turns it off on the Shared row) for a full-quality run.
 *
 *   - unset / absent / null / undefined  → ON  (default)
 *   - explicit opt-out ('off'/'false'/'0'/'no' or bool false) → OFF
 *   - anything else truthy ('on'/'true'/'1'/bool true / unknown) → ON
 */

const OFF_TOKENS = new Set(['off', 'false', '0', 'no']);

/**
 * @param {unknown} raw The ``economyMode`` value off a __roomContext__ row (bool | string | nullish).
 * @returns {boolean} Whether economy mode is active (default true).
 */
export function isEconomyOn(raw) {
  if (raw == null) return true; // unset → default ON
  if (typeof raw === 'boolean') return raw;
  return !OFF_TOKENS.has(String(raw).trim().toLowerCase());
}

/**
 * Resolve economy mode from a network summary's agents map (the room path).
 * Reads the reserved ``__roomContext__`` Shared row; default ON when the row/flag is absent.
 *
 * @param {Record<string, unknown> | null | undefined} agents The network's agents map.
 * @returns {boolean}
 */
export function economyFromAgents(agents) {
  const rc = agents && typeof agents === 'object' ? agents.__roomContext__ : null;
  const raw = rc && typeof rc === 'object' ? rc.economyMode : undefined;
  return isEconomyOn(raw);
}
